// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Point } from '@shared/commons/Geometry';
import { ChartMath } from '../Utils/ChartMath';
import { TerceraChartCashItemSeriesDataType } from '../Series/TerceraChartCashItemSeriesEnums';
import { ToolView } from './ToolView';
export class CurveToolView extends ToolView {
    UpdateScreenPoints(ww, cashItemSeries) {
        const dataCacheTool = this.dataCacheTool;
        //
        // callback need recalculate points
        //
        if (dataCacheTool.forceUpdateAdditionalPoints) {
            dataCacheTool.forceUpdateAdditionalPoints = false;
            this.UpdateAdditionalPoints(ww, -1, cashItemSeries);
        }
        this.UpdateScreenPointsALL(ww, cashItemSeries, false);
        const dataType = (cashItemSeries === null || cashItemSeries === void 0 ? void 0 : cashItemSeries.settings)
            ? cashItemSeries.settings.DataType
            : TerceraChartCashItemSeriesDataType.Absolute;
        const tmp = [];
        const pc = ww.PointsConverter;
        const scrPointsLen = this.screenPoints.length;
        for (let i = dataCacheTool.PointLevel(); i < scrPointsLen; i++) {
            const p = dataCacheTool.Points[i];
            const x = pc.GetScreenXbyTime(p[0]);
            const y = pc.GetScreenY(cashItemSeries.settings.CalculateConverter(p[1]));
            tmp.push(new Point(x, y));
        }
        this.lastCurvePoints = tmp;
    }
    IsSelectCheck(x, y) {
        const lastCurvePoints = this.lastCurvePoints;
        if (lastCurvePoints) {
            const TOOL_DX = ToolView.TOOL_DX;
            const len = lastCurvePoints.length;
            // весь контур
            for (let i = 1; i < len; i++) {
                if (ChartMath.CalcDistanceSqrFromPointToSection([lastCurvePoints[i - 1].X, lastCurvePoints[i - 1].Y], [lastCurvePoints[i].X, lastCurvePoints[i].Y], x, y) <= TOOL_DX) {
                    return true;
                }
            }
        }
        return super.IsSelectCheck(x, y);
    }
}
